import { render, staticRenderFns } from "./TranslationBillingForm.vue?vue&type=template&id=d99a653c"
import script from "./TranslationBillingForm.vue?vue&type=script&lang=js"
export * from "./TranslationBillingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports